export default "__VITE_ASSET__257d00f4__"